import styled from 'styled-components';
import {
    pearlConnectFormFieldOverrides,
    PEARL_CONNECT_ACCENT,
    PEARL_CONNECT_FIELD_STROKE,
    PEARL_CONNECT_FIELD_RADIUS,
} from 'vendor/styles/pearlConnectFormUiOverrides';

const VendorCheckoutFormStyled = styled.form`
    ${pearlConnectFormFieldOverrides}

    .formWrapper {
        .checkoutContainer {
            display: flex;
            align-items: flex-start;
            width: 100%;
            @media (min-width: 816px) {
                gap: 16px;
                justify-content: flex-start;
                align-items: flex-start;
                & > *:nth-child(1) {
                    flex: 0 0 432px;
                    width: 432px;
                    max-width: 432px;
                }
                & > *:nth-child(2) {
                    flex: 1 1 560px;
                    width: auto;
                    min-width: 560px;
                    max-width: 720px;
                }
            }
            @media (max-width: 815px) {
                flex-direction: column;
                gap: 24px;
                margin-bottom: 80px;
                & > * {
                    width: 100%;
                    max-width: 100%;
                }
            }
        }
    }

    .label {
        font-weight: 700 !important;
    }
    .errorContainer {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .error-text {
        color: red;
        font-size: 12px;
        // padding-top: 8px;
        padding-left: 16px;
        // padding-bottom: 8px;
        &:last-child {
            padding-bottom: 8px;
        }
    }

    .pearl-connect-checkout .card {
        border-radius: ${PEARL_CONNECT_FIELD_RADIUS};
        border-color: ${PEARL_CONNECT_FIELD_STROKE} !important;
    }

    .pearl-connect-checkout .card.StripeElement--focus,
    .pearl-connect-checkout .card:focus-within {
        border-color: ${PEARL_CONNECT_ACCENT} !important;
    }

    .pearl-connect-checkout
        .toggle-switch-container
        .MuiSwitch-switchBase.Mui-checked
        + .MuiSwitch-track {
        background-color: ${PEARL_CONNECT_ACCENT} !important;
        opacity: 1 !important;
    }
`;

export { VendorCheckoutFormStyled };
